import { useMemo } from 'react'
import { keyBy } from 'lodash'
import { getDungeons } from 'app/frontend/base/services/dungeonValues'
import KeystoneRunCard from 'app/frontend/base/components/KeystoneRunCard'
import { useCharacterKeystones } from '../hooks/useCharacterKeystones'
import { usePageInfo } from 'app/frontend/base/config/queries'

interface Props {
  character?: wowaudit.Character
  weeksAgo: number
  minKeyLevel?: number
}

const WeeklyKeystones = ({ character, weeksAgo, minKeyLevel }: Props) => {
  const { runs, isLoaded } = useCharacterKeystones(
    character,
    weeksAgo,
    minKeyLevel,
  )
  const {
    data: { gameVersion },
  } = usePageInfo()
  const dungeons = useMemo(
    () => keyBy(getDungeons(gameVersion), 'id'),
    [gameVersion],
  )

  return (
    <div className='min-h-10'>
      {runs.length ? (
        <div className='flex flex-wrap gap-2'>
          {runs.map((run) => (
            <KeystoneRunCard
              key={run.key}
              run={run}
              dungeon={dungeons[run.dungeon]}
            />
          ))}
        </div>
      ) : isLoaded ? (
        <div className='text-sm text-muted-foreground pt-2'>
          No dungeons completed{' '}
          {weeksAgo === 0
            ? 'this week. This data can take some time to update.'
            : `${weeksAgo} ${weeksAgo === 1 ? 'week' : 'weeks'} ago.`}
        </div>
      ) : null}
    </div>
  )
}

export default WeeklyKeystones
